import Axios from "axios";
import { variables } from "../variables";
const endPoint = variables.serverUrl;
const loginUrl = `${endPoint}/oauth/token`;
import qs from "query-string";

export default {
    state: {
        authenticated: false,
        accessToken: null,
        username: null,
        applicationId: null,
        jti: null,
        paymentApproved: false,
        userType: null,   
        welcomeMessage: false,
        spouse: false,
        spouseDataUpload: false,
        club: null
    },
    getters: {
        api(state) {
            return Axios.create({
                headers: {
                    "Authorization": `Bearer ${state.accessToken}`,
                    "Accept-Language": "es-MX",
                    "Content-Type": "application/json"
                },
                baseURL: `${endPoint}/api/v1`
            });
        },
        getUserName(state){
            return state.username;
        },
        getApplicationID(state){
            return state.applicationId;
        },
        getPaymentApproved(state){
            return state.paymentApproved;
        },
        getUserType(state){
            return state.userType
        },
        getWelcomeMessage(state){
            return state.welcomeMessage;
        },
        getSpouseState(state){
            return state.spouse;
        },
        getSpouseData(state){
            return state.spouseDataUpload;
        }
    },
    mutations: {
        setAuthenticated(state, header) {
            if(!localStorage.getItem('access_token')) {
                localStorage.setItem('access_token', header.access_token);
                state.accessToken = header.access_token;
            } else {
                state.accessToken = localStorage.getItem('access_token');
            }
        
            state.applicationId = header.applicationNumber;
            state.jti = header.jti;
            state.paymentApproved = header.paymentApproved;
            state.welcomeMessage = header.welcomeMessage;
            state.userType = header.userType
            state.club = header.club;
            state.authenticated = true;
        },
        setPaymentApproved(state, pa){
            state.paymentApproved = pa;
        },
        setApplicationId(state, folio){
            state.applicationId = folio;
        },
        setSpouseState(state, data){
          state.spouse = data;
        },
        setSpouseData(state, data){
           state.spouseDataUpload = data;
        },
        setUserName(state, data){
            state.username = data;
        },
        clearAuthentication(state) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('username');
            localStorage.removeItem('selected');
            localStorage.removeItem('application_id');
            localStorage.removeItem('jti');
            localStorage.removeItem('payment_approved')
            state.username = null;
            state.applicationId = null;
            state.jti = null;
            state.authenticated = false;
            state.accessToken = null;
            state.paymentApproved = null;
            state.userType = null;
            state.spouse = false;
            state.spouseDataUpload = false;
            state.club = null;
        }
    },
    actions: {
        async authenticate(context, credentials) {
            let formData = {};
            formData.username = credentials.email;
            formData.password = credentials.password;
            formData.grant_type = 'password';
            let response = await Axios.post(loginUrl, qs.stringify(formData), {
                auth: {
                    username: 'aZ3gGh2Ehfe2rJYUxLKZ',
                    password: 't7ANVbSkM5VJpyTTMt2RMdEjTZiWim'
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept-Language': 'es-MX'
                }
            });
            if(response.status == 200) {
                context.commit("setAuthenticated", response.data);
                context.commit("setMenuIndex",1);
                context.commit("setUserName", credentials.email)
            }
        },
        async logOut(context) {
            await context.commit("clearAuthentication");
            await context.commit("CleanApplicant")
            await context.commit("CleanApplicationData")
        },
        async setPaymentDoneAgain(context, state){
            context.commit("setPaymentApproved", state);
        }
    }
}